<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="mt-1 mb-2 d-flex align-center">
        <h2 class="text-h6 font-weight-bold">WALK IN</h2>
        <v-spacer></v-spacer>
        <v-btn
          icon
          title="Open in new window"
          @click="openInNewWindow"
        >
          <v-icon small>mdi-open-in-new</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="12" class="mt-1">
        <v-alert
          v-if="!queueId"
          type="warning"
          dense
        >
          No queue configured. Launch this page with a <strong>queueId</strong> URL parameter.
        </v-alert>

        <v-text-field
          v-if="queueId"
          label="Queue"
          :value="queueName || queueId"
          outlined
          readonly
          disabled
        ></v-text-field>
      </v-col>

      <!-- <v-col cols="12">
        <v-text-field+/
          label="Customer Reference (optional)"
          v-model="ticketNumber"
          outlined
          :disabled="ui.loading"
        ></v-text-field+>
      </v-col> -->

      <v-col cols="12" class="mb-10 ml-1">
        <v-btn
          color="primary"
          :disabled="!queueId || ui.loading"
          :loading="ui.loading"
          @click="startWalkIn"
          x-large
          style="height: 80px; font-size: 1.5rem;"
        >
          Start Walk-In
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-alert
          class="mb-0"
          :type="ui.showAlertType"
          dense
          :value="ui.showAlert"
        >
          {{ ui.displayResponse }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

/* eslint-disable */
let conversationsApi = new platformClient.ConversationsApi();
let usersApi = new platformClient.UsersApi();
let presenceApi = new platformClient.PresenceApi();

export default {
  name: "WalkIn",
  props: ["accessToken", "userEmail", "userOrg", "urlParams"],

  data: () => ({
    userId: null,
    queueId: null,
    queueName: null,
    ticketNumber: null,
    presenceId: null,
    presenceSystemPresence: null,
    ui: {
      loading: false,
      showAlert: false,
      showAlertType: "success",
      displayResponse: null,
    },
  }),

  created() {
    this.getUserId();
  },

  watch: {
    urlParams: {
      handler(params) {
        if (params) {
          this.queueId = params.queueId || null;
          this.queueName = params.queueName || null;
          this.presenceId = params.presenceId || null;
          this.presenceSystemPresence = params.presenceSystemPresence || null;
        }
      },
      immediate: true,
    },
  },

  methods: {
    getUserId() {
      usersApi
        .getUsersMe({})
        .then((data) => {
          this.userId = data.id;
          console.log("[WalkIn] User ID retrieved:", this.userId);
        })
        .catch((err) => {
          console.error("[WalkIn] getUsersMe failed:", err);
        });
    },

    startWalkIn() {
      this.ui.showAlert = false;
      this.ui.loading = true;

      if (!this.presenceId) {
        console.warn("[WalkIn] No presenceId provided, skipping presence update.");
      }

      if (this.userId && this.presenceId) {
        presenceApi
          .patchUserPresencesPurecloud(this.userId, 
            {
              "presenceDefinition": {
                "id": this.presenceId,
                "systemPresence": this.presenceSystemPresence || "Busy"
              },
            })
          .then(() => {
            console.log("[WalkIn] Agent set to Off Queue");
            this.createEmailConversation();
          })
          .catch((err) => {
            console.warn("[WalkIn] Failed to set Off Queue status, continuing:", err);
            this.createEmailConversation();
          });
      } else {
        this.createEmailConversation();
      }
    },

    createEmailConversation() {
      let body = {
        queueId: this.queueId,
        provider: "TCC",
        direction: "OUTBOUND",
        toName: `WALK-IN ${this.queueName || this.queueId}`,
        subject: "WALK-IN",
        toAddress: `WALK-IN ${this.queueName || this.queueId}`,
      };

      if (this.ticketNumber) {
        body.attributes = { ticketNumber: this.ticketNumber };
      }

      conversationsApi
        .postConversationsEmails(body)
        .then((response) => {
          console.log("[WalkIn] Conversation created:", response.id);
          this.ui.showAlertType = "success";
          this.ui.displayResponse = `Walk-In started successfully. Conversation ID: ${response.id}`;
          this.ui.showAlert = true;
          this.ui.loading = false;

          if (this.ticketNumber) {
            const savedRef = this.ticketNumber;
            setTimeout(() => {
              this.patchConversationReference(response.id, savedRef);
            }, 2000);
          }
          this.ticketNumber = null;
        })
        .catch((error) => {
          console.error("[WalkIn] Conversation creation failed:", error);
          this.ui.showAlertType = "error";
          this.ui.displayResponse = error.message || "There was an error creating the Walk-In.";
          this.ui.showAlert = true;
          this.ui.loading = false;
        });
    },

    openInNewWindow() {
      const params = new URLSearchParams();
      if (this.queueId) params.set("queueId", this.queueId);
      if (this.queueName) params.set("queueName", this.queueName);
      if (this.presenceId) params.set("presenceId", this.presenceId);
      if (this.presenceSystemPresence) params.set("presenceSystemPresence", this.presenceSystemPresence);
      const url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
      window.open(url, "_blank");
    },

    patchConversationReference(conversationId, ticketNumber) {
      conversationsApi
        .getAnalyticsConversationDetails(conversationId)
        .then((response) => {
          const participantId = response.participants[0].participantId;
          return conversationsApi.patchConversationParticipantAttributes(
            conversationId,
            participantId,
            { attributes: { ticketNumber } }
          );
        })
        .then(() => {
          console.log("[WalkIn] Reference attribute patched for conversation:", conversationId);
        })
        .catch((err) => {
          console.error("[WalkIn] Failed to patch conversation reference:", err);
        });
    },
  },
};
</script>
